export interface BenefitGroup {
  title: string
  items: { id: string; percentage: number; text: string }[]
}
// Informational content shared by Bienvenida and Pagos. No calculation of eligibility.
export const supportBenefits: BenefitGroup[] = [
  {
    title: 'Al contratar',
    items: [
      { id: 'credit-score', percentage: 5, text: 'Por Score en Buró de Crédito' },
      { id: 'direct-debit', percentage: 5, text: 'Por domiciliar tus pagos' }
    ]
  },
  {
    title: 'Durante tu financiamiento',
    items: [
      { id: 'initial-payment', percentage: 5, text: 'Por Pago Puntual Inicial' },
      { id: 'continued-payment', percentage: 5, text: 'Por Pago Puntual Sostenido' },
      { id: 'referral', percentage: 5, text: 'Por clientes referidos' },
      { id: 'later-direct-debit', percentage: 5, text: 'Por domiciliación posterior a la contratación' }
    ]
  }
]
